// import the react components
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
import { ContextProvider } from "./context/";
import "./assets/styles/index.css";
import "./assets/fonts/ubuntu-regular.ttf";

// create the root of the application
const root = ReactDOM.createRoot(document.querySelector("#root"));
root.render(
    <ContextProvider>
        <App />
    </ContextProvider>
);